Ext.define('SA.view.FileInput', {
    alias: 'widget.file-input',
    extend: 'Ext.Component',

    autoEl: 'label',
    baseCls: 'sa-file-input',

    html: [
        '<div class="sa-file-input-filename-wrap">',
            '<div class="sa-file-input-filename"></div>',
        '</div>',
        '<div class="sa-file-input-btn">Browse…</div>',
        '<input type="file" class="sa-file-input-input">'
    ],

    getFile() {
        return this.input.files[0] || null;
    },

    onBoxReady() {
        this.callParent();

        this.input = this.el.query('input')[0];
        this.filenameEl = this.el.query('.sa-file-input-filename')[0];

        this.input.addEventListener('change', () => this.refreshFilenameText());
    },

    refreshFilenameText() {
        var {name: filename} = this.getFile() || {};

        this.filenameEl.textContent = filename;
    }
});